import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {Avatar, IconButton, IconMenu, MenuItem, Chip} from "material-ui";
import {ListItem} from 'material-ui/List';
import {grey400} from 'material-ui/styles/colors';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import style from '../../../styles/styles';
import AdminService, {ADMIN} from "../../../services/admin";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_TYPE_PAGE, TYPE_PAGE} from "../../../constants/routes";
import styles from "../../media/Media/Media.css";

class Type extends React.Component {

    static propTypes = {
        type: PropTypes.object.isRequired,
        app: PropTypes.object,
        user: PropTypes.object,
        handleRemoveType: PropTypes.func
    };

    handleRemoveType = () => {
        this.props.handleRemoveType(this.props.type);
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                <Link to={TYPE_PAGE.replace(':appId', this.props.app.id).replace(':typeId', this.props.type.id)}>
                    <MenuItem>
                        {this.props.t('generic.detail')}
                    </MenuItem>
                </Link>
                {AdminService.isAuthorized(ADMIN, this.props.user) &&
                    <Link to={EDIT_TYPE_PAGE.replace(':appId', this.props.app.id).replace(':typeId', this.props.type.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                }
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.props.handleRemoveType &&
                    <MenuItem onClick={this.handleRemoveType}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                }
            </IconMenu>
        )
    };

    render() {
        const {type} = this.props;

        return (
            <ListItem
                leftAvatar={
                    <Avatar
                        icon={type.picture && <img src={type.picture} alt="" style={style.image.contain}/>}
                        size={40}
                        backgroundColor={type.color}
                        style={{ overflow: 'hidden' }}
                    />
                }
                primaryText={<div>
                    {type.name}
                    {type.tag &&
                    <Chip style={{...styles.chip, ...style.chip}}>
                        {type.tag}
                    </Chip>
                    }
                </div>}
                secondaryText={type.id}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(Type);



// WEBPACK FOOTER //
// src/components/type/Type/Type.js